function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#95bf47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.3 308s-6 1.7-15.9 4.7c-1.7-5.6-4.3-12-7.7-18.9-11.2-21.5-27.9-33.1-47.7-33.1-1.3 0-2.6 0-4.3.4-.4-.9-1.3-1.3-1.7-2.1-8.6-9.5-19.8-13.8-33.1-13.3-25.8.9-51.6 19.3-72.2 52.4-14.6 23.2-25.8 52.4-28.8 75.2-29.7 9-50.3 15.5-50.7 15.9-15 4.7-15.5 5.2-17.2 19.3-1.3 10.7-40.8 313.4-40.8 313.4l325 56.3V307.6c-2.7 0-4 .4-4.9.4zm-75.2 23.2c-17.2 5.2-36.1 11.2-54.6 16.8 5.2-20.2 15.5-40.4 27.5-53.7 4.7-4.7 11.2-10.3 18.5-13.8 7.3 15.5 9 36.6 8.6 50.7zm-35.2-67.9c6 0 11.2 1.3 15.5 3.9-6.9 3.4-13.8 9-20.2 15.5-16.3 17.6-28.8 45.1-34 71.4-15.5 4.7-31 9.5-45.1 13.8 9.4-41.4 44.2-103.7 83.8-104.6zM437 499.8c1.7 27.5 74.4 33.5 78.7 98.4 3 51.2-27.1 86-70.5 88.6-52.4 3.4-81.2-27.5-81.2-27.5l11.2-47.3s28.8 21.9 52 20.2c15-.9 20.6-13.3 20.2-21.9-2.1-36.1-61.5-34-65.3-93.3-3.4-49.9 29.2-100.2 101.5-104.9 27.9-1.7 42.1 5.2 42.1 5.2l-16.3 61.9s-18.5-8.6-40.4-6.9c-32 2.1-32.4 22.3-32 27.5zm102.3-173.7c0-12.9-1.7-31.4-7.7-46.9 19.8 3.9 29.2 25.8 33.5 39.1-7.7 2.2-16.3 4.8-25.8 7.8zM612 777.5 747 744s-58-392.5-58.5-395.1c-.4-2.6-2.6-4.3-4.7-4.3s-40-.9-40-.9-23.2-22.4-31.8-31v464.8z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/shopify.162913e43c02c125fd0720d80fc0dba3.svg";
export { ForwardRef as ReactComponent };